import { useContextTranslation } from '@core/i18n';
import { isLiveStream } from '@core/livestream/helpers';
/**
 *
 */
export const useShareMessage = (video) => {
    const { t } = useContextTranslation();
    const messages = {
        'an exciting event': t(`player:Check out {{videoCaption}}, an exciting event by {{hostName}}.`, {
            videoCaption: video?.caption,
            hostName: video?.creator?.name,
        }),
        'a video': t(`player:Check out {{videoCaption}}, a video by {{hostName}}.`, {
            videoCaption: video?.caption,
            hostName: video?.creator?.name,
        }),
    };
    const adjectiveKey = isLiveStream(video) ? 'an exciting event' : 'a video';
    return messages[adjectiveKey];
};
